export default {
  updateAiSetting: [],
  updateAiTemplate: [],
  updateAiTemplateSection: [],
  updateAiReport: [],
};
